export default __webpack_public_path__ + "9f8c5f41d86668d2980d4b21e752885e.jpg";